// extracted by mini-css-extract-plugin
module.exports = {"view":"views-Browse__view--3m1D_"};